import { Component, EventEmitter, Injector, Input, Output } from '@angular/core';
declare let $: any;

@Component({
    selector: 'app-horizontal-item',
    templateUrl: './horizontal-item.component.html',
    styleUrls: ['./horizontal-item.component.scss']
})
export class HorizontalItemComponent {

    @Input() item;
    @Input() isActive: boolean;
    @Output()
    public toggleSubmenuClick = new EventEmitter<MouseEvent>();

    toggleSubmenu(event: MouseEvent) {
        this.toggleSubmenuClick.emit(event);
    }
}
